import { useDocumentTitle } from '@/hooks';
import { AuthPanel, RegisterForm } from '../components';

export function RegisterPage() {
  useDocumentTitle('Criar conta');

  return (
    <AuthPanel title="Criar conta">
      <RegisterForm />
    </AuthPanel>
  );
}
